<lib-button forceContext="publicSessionEditor" (click)="openOptions()" translate>clgmdsmms000008jq63aj4o7l</lib-button>
